import React, { useContext, useEffect, useState } from 'react';
import { Input } from 'antd';
import PropTypes from 'prop-types';
import icons from '../../main/utils/icons';
import GlobalContext from '../../main/utils/GlobalContext';

function InputSearch({ onSearch, searchPlaceholder = null, loading = false }) {
  const { locales } = useContext(GlobalContext);
  const [searchValue, setSearchValue] = useState();
  const placeholder = searchPlaceholder || locales.admin.searchByName;
  const handleSearch = (e) => {
    setSearchValue(e.currentTarget.value);
  };

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      onSearch(searchValue);
    }, 300);
    return () => clearTimeout(delayDebounceFn);
  }, [searchValue]);
  return (
    <Input
      allowClear
      className="admin-table-search"
      suffix={icons.searchIcon}
      placeholder={placeholder}
      width={200}
      onChange={(e) => {
        if (e.currentTarget.value === '') {
          setSearchValue(null);
        }
      }}
      onPressEnter={handleSearch}
      disabled={loading}
    />
  );
}

InputSearch.propTypes = {
  searchPlaceholder: PropTypes.string,
  onSearch: PropTypes.func,
  loading: PropTypes.bool,
};
export default InputSearch;
